<medrecord-choice-radio-question (answer)="emitAnswers($event)"
                                 [currentAnswer]="getCurrentAnswer()"
                                 [question]="getQuestion()"
></medrecord-choice-radio-question>
